export const columnData = {
  DateCreated: { name: 'Fecha', widthCol: '30%' },
  Message: { name: 'Mensaje', widthCol: '80%' },
  Severity: { name: 'Tipo', widthCol: '100%' }
}
